// extracted by mini-css-extract-plugin
module.exports = {"app-button":"_button_app-button__2XfuH","outline":"_button_outline__1Wj2y","rounded":"_button_rounded__3-Hfn"};